import React from 'react';
import { Breadcrumbs, makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  textSm: {
    fontSize: 12,
  },
  linkBlock: {
    display: 'block',
    color: 'inherit',
  },
}));

const PageBreadcrumbs = ({ items, ...rest }) => {
  const classes = useStyles();

  return (
    <Breadcrumbs style={{ color: 'white' }} className="bread-crumbs" aria-label="breadcrumb {...rest}">
      {items.map((item, index) =>
        item.isActive ? (
          <Typography style={{ color: 'white' }} key={index} className={classes.textSm}>
            {item.label}
          </Typography>
        ) : (
          <NavLink key={index} className={clsx(classes.textSm, classes.linkBlock)} color="inherit" to={item.link || '/'}>
            {item.label}
          </NavLink>
        ),
      )}
    </Breadcrumbs>
  );
};

export default PageBreadcrumbs;
